import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { Box, Modal, Typography } from "@mui/material";
import { cssProperties } from "../../../utils/commonCssProperties";
import commonActions from "../../../redux/common/actions";
import examScheduleActions from "../../../redux/examSchedule/actions";
import CancelButton from "../../../common/button/cancelButton";
import BluePrimaryButton from "../../../common/button/bluePrimaryButton";
import ButtonLoader from "../../../common/buttonLoader";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 500,
  bgcolor: `${cssProperties?.backgroundcolor?.secondary}`,
  padding: "24px",
  borderRadius: "8px",
};

/** Soft-deletes either row type — the row carries its own row_type. */
export default function DeleteModal({ courseid }) {
  const dispatch = useDispatch();
  const { showModal, buttonLoader } = useSelector((state) => state.commonReducer);
  const { backofficeTokenDetails } = useSelector((state) => state.authReducer);

  const row = showModal?.data;

  const handleClose = () => {
    dispatch({
      type: commonActions.SET_SHOW_MODAL,
      payload: { show: false, type: null, method: null, data: null },
    });
  };

  const handleDelete = () => {
    dispatch({
      type: examScheduleActions.DELETE_SCHEDULE_ROW,
      payload: {
        id: row?.id,
        courseid,
        rowType: row?.row_type,
        userid: Number(backofficeTokenDetails?.id),
        handleClose,
      },
    });
  };

  return (
    <Modal
      open={!!(showModal?.show && showModal?.method === "ESD")}
      aria-labelledby="exam-schedule-delete-modal"
    >
      <Box sx={style}>
        <Typography
          variant="h5"
          sx={{
            color: `${cssProperties?.color?.primary}`,
            fontWeight: "500",
            marginBottom: "18px",
          }}
        >
          Delete Row
        </Typography>
        <Box>
          Are you sure you want to remove{" "}
          <strong>{row?.row_type === "PAPER" ? row?.papername : row?.label}</strong> from
          this course's admit-card schedule?
        </Box>
        <Box sx={{ display: "flex", justifyContent: "flex-end", gap: "12px", marginTop: "32px" }}>
          <CancelButton handleBack={handleClose} />
          <BluePrimaryButton
            title={buttonLoader ? <ButtonLoader /> : "Delete"}
            handleSubmit={handleDelete}
          />
        </Box>
      </Box>
    </Modal>
  );
}
